module.exports = __webpack_public_path__ + "media/images/about/a3-4faf27c4ed9e6445ea09efff26c1709e.png";